"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _KnockRequestListItem = require("./KnockRequestListItem.styled");
var _AcceptAs = _interopRequireDefault(require("./AcceptAs"));
var _utils = require("../../../utils");
var _resources = require("../../../resources");
var _ = require("../..");
var KnockRequestListItem = function KnockRequestListItem(_ref) {
  var zIndex = _ref.zIndex,
    name = _ref.name,
    onApprove = _ref.onApprove,
    onReject = _ref.onReject,
    animation = _ref.animation,
    maxCamerasExceeded = _ref.maxCamerasExceeded,
    onAVClicked = _ref.onAVClicked,
    isCameraOn = _ref.isCameraOn,
    isMicrophoneOn = _ref.isMicrophoneOn,
    socketId = _ref.socketId,
    sources = _ref.sources;
  _react["default"].useEffect(function () {
    var audio = new Audio(knockSound);
    audio.play();
  }, []);
  var knockSound = _resources.resources.knockSound;
  var title = 'New presenter request';
  var icon = _freeSolidSvgIcons.faDoorOpen;
  var message = 'wants access';
  var hideAVIcons = false;
  var hasDropDownButton = !hideAVIcons && sources && sources.length > 0;
  var filteredSources = sources.filter(function (s) {
    if (!s.isInitializing) {
      return s;
    }
  });
  if (typeof maxCamerasExceeded !== 'boolean') maxCamerasExceeded = false;
  var onCameraToggle = function onCameraToggle() {
    // Check limit before allowing extra camera on
    if (maxCamerasExceeded) return;
    onAVClicked(socketId, !isCameraOn, isMicrophoneOn);
  };
  var onMicrophoneToggle = function onMicrophoneToggle() {
    onAVClicked(socketId, isCameraOn, !isMicrophoneOn);
  };
  var isLongMessage = "".concat((0, _utils.truncate)(name)).concat(message).length > 35;
  var targetElements = ["cameraToggle".concat(socketId), "micToggle".concat(socketId), "requestMessage".concat(socketId)];
  return /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledKnockRequestItemWrapper, (0, _extends2["default"])({
    role: "alert",
    "aria-live": "polite",
    zIndex: zIndex
  }, animation, {
    hideAVIcons: hideAVIcons,
    hasDropDownButton: hasDropDownButton,
    isLongMessage: isLongMessage
  }), /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledRow, null, /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledCol, {
    md: 3
  }, /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledDoorIcon, {
    icon: icon,
    "aria-hidden": true
  })), /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledCol, {
    md: 9
  }, /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledKnockRequestItemTitle, null, title), /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledKnockRequestItemBody, null, /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledGuestName, {
    id: targetElements[2],
    className: "dd-privacy-mask"
  }, (0, _utils.truncate)(name), " ", message)), /*#__PURE__*/_react["default"].createElement(_.ToolTip, {
    targetElement: targetElements[2],
    message: name
  }))), /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledRow, null, /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledCol, {
    md: 12
  }, /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledKnockRequestItemFooter, {
    addTopMargin: isLongMessage
  }, hasDropDownButton ? /*#__PURE__*/_react["default"].createElement(_AcceptAs["default"], {
    sources: filteredSources,
    onApprove: onApprove,
    name: name
  }) : /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledAcceptKnockButton, {
    "data-testid": "knock-approve-button-".concat(name),
    onClick: function onClick() {
      onApprove();
    },
    "aria-label": "Approve ".concat(name, "'s request")
  }, /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledFontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faCheck,
    "aria-hidden": true
  }), "Approve"), /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledRejectKnockButton, {
    "data-testid": "knock-reject-button-".concat(name),
    onClick: onReject,
    "aria-label": "Reject ".concat(name, "'s request")
  }, /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledFontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faTimesCircle,
    "aria-hidden": true
  }), "Reject")), !hideAVIcons && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledFooterIconsWrapper, null, /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledFooterCaption, {
    isDisabled: maxCamerasExceeded
  }, "Camera"), /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledFooterIcon, {
    screenReaderText: "Camera Status",
    $isDisabled: maxCamerasExceeded,
    active: isCameraOn,
    activeIcon: _freeSolidSvgIcons.faVideo,
    inactive: !isCameraOn,
    inactiveIcon: _freeSolidSvgIcons.faVideoSlash,
    onClick: onCameraToggle,
    id: targetElements[0]
  }), /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledFooterCaption, null, "Mic"), /*#__PURE__*/_react["default"].createElement(_KnockRequestListItem.StyledFooterIcon, {
    screenReaderText: "MIC Status",
    active: isMicrophoneOn,
    activeIcon: _freeSolidSvgIcons.faMicrophoneAlt,
    inactive: !isMicrophoneOn,
    inactiveIcon: _freeSolidSvgIcons.faMicrophoneAltSlash,
    onClick: onMicrophoneToggle,
    id: targetElements[1]
  })), /*#__PURE__*/_react["default"].createElement(_.ToolTip, {
    targetElement: targetElements[1],
    message: "Unmuted mics will be live"
  })))));
};
KnockRequestListItem.propTypes = {
  name: _propTypes["default"].string.isRequired,
  onApprove: _propTypes["default"].func.isRequired,
  onReject: _propTypes["default"].func.isRequired,
  zIndex: _propTypes["default"].number.isRequired,
  animation: _propTypes["default"].shape({
    initial: _propTypes["default"].object,
    animate: _propTypes["default"].object,
    exit: _propTypes["default"].object,
    transition: _propTypes["default"].object
  }),
  requestType: _propTypes["default"].string,
  maxCamerasExceeded: _propTypes["default"].bool.isRequired,
  onAVClicked: _propTypes["default"].func.isRequired,
  isCameraOn: _propTypes["default"].bool,
  isMicrophoneOn: _propTypes["default"].bool,
  socketId: _propTypes["default"].string.isRequired,
  sources: _propTypes["default"].array
};
KnockRequestListItem.defaultProps = {
  isCameraOn: true,
  isMicrophoneOn: false
};
var _default = exports["default"] = KnockRequestListItem;